import "core-js/modules/es.function.name.js";
import React from 'react';
import { Hint } from '../../Hint';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var positions = ['default', 'left', 'right', 'bottom-static'];
export var InputHint = function InputHint(_ref) {
  var name = _ref.name,
      view = _ref.view,
      position = _ref.position,
      content = _ref.content,
      info = _ref.info,
      warning = _ref.warning,
      error = _ref.error;

  if (info) {
    content = info;
    view = 'info';
  }

  if (warning) {
    content = warning;
    view = 'warning';
  }

  if (error) {
    content = error;
    view = 'error';
  }

  if (!content) {
    return null;
  }

  return ___EmotionJSX(Hint, {
    testId: "".concat(name, "-inputHint"),
    view: view,
    position: position
  }, content);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21tb24vSW5wdXQvSGludC9pbmRleC50c3giXSwibmFtZXMiOlsiUmVhY3QiLCJIaW50IiwicG9zaXRpb25zIiwiSW5wdXRIaW50IiwibmFtZSIsInZpZXciLCJwb3NpdGlvbiIsImNvbnRlbnQiLCJpbmZvIiwid2FybmluZyIsImVycm9yIl0sIm1hcHBpbmdzIjoiO0FBQUEsT0FBT0EsS0FBUCxNQUFpQyxPQUFqQztBQUNBLFNBQVNDLElBQVQsUUFBK0IsWUFBL0I7O0FBRUEsT0FBTyxJQUFNQyxTQUFTLEdBQUcsQ0FBQyxTQUFELEVBQVksTUFBWixFQUFvQixPQUFwQixFQUE2QixlQUE3QixDQUFsQjtBQWNQLE9BQU8sSUFBTUMsU0FBMEIsR0FBRyxTQUE3QkEsU0FBNkIsT0FRcEM7QUFBQSxNQVBKQyxJQU9JLFFBUEpBLElBT0k7QUFBQSxNQU5KQyxJQU1JLFFBTkpBLElBTUk7QUFBQSxNQUxKQyxRQUtJLFFBTEpBLFFBS0k7QUFBQSxNQUpKQyxPQUlJLFFBSkpBLE9BSUk7QUFBQSxNQUhKQyxJQUdJLFFBSEpBLElBR0k7QUFBQSxNQUZKQyxPQUVJLFFBRkpBLE9BRUk7QUFBQSxNQURKQyxLQUNJLFFBREpBLEtBQ0k7O0FBQ0osTUFBSUYsSUFBSixFQUFVO0FBQ1JELElBQUFBLE9BQU8sR0FBR0MsSUFBVjtBQUNBSCxJQUFBQSxJQUFJLEdBQUcsTUFBUDtBQUNEOztBQUVELE1BQUlJLE9BQUosRUFBYTtBQUNYRixJQUFBQSxPQUFPLEdBQUdFLE9BQVY7QUFDQUosSUFBQUEsSUFBSSxHQUFHLFNBQVA7QUFDRDs7QUFFRCxNQUFJSyxLQUFKLEVBQVc7QUFDVEgsSUFBQUEsT0FBTyxHQUFHRyxLQUFWO0FBQ0FMLElBQUFBLElBQUksR0FBRyxPQUFQO0FBQ0Q7O0FBRUQsTUFBSSxDQUFDRSxPQUFMLEVBQWM7QUFDWixXQUFPLElBQVA7QUFDRDs7QUFFRCxTQUNFLGNBQUMsSUFBRDtBQUFNLElBQUEsTUFBTSxZQUFLSCxJQUFMLGVBQVo7QUFBbUMsSUFBQSxJQUFJLEVBQUVDLElBQXpDO0FBQStDLElBQUEsUUFBUSxFQUFFQztBQUF6RCxLQUNHQyxPQURILENBREY7QUFLRCxDQWpDTSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBSZWFjdE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBIaW50LCBWaWV3SGludCB9IGZyb20gJy4uLy4uL0hpbnQnO1xuXG5leHBvcnQgY29uc3QgcG9zaXRpb25zID0gWydkZWZhdWx0JywgJ2xlZnQnLCAncmlnaHQnLCAnYm90dG9tLXN0YXRpYyddIGFzIGNvbnN0O1xuXG5leHBvcnQgdHlwZSBQb3NpdGlvbiA9IHR5cGVvZiBwb3NpdGlvbnNbbnVtYmVyXTtcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgbmFtZTogc3RyaW5nIHwgdW5kZWZpbmVkO1xuICB2aWV3OiBWaWV3SGludCB8IHVuZGVmaW5lZDtcbiAgcG9zaXRpb246IFBvc2l0aW9uO1xuICBjb250ZW50OiBSZWFjdE5vZGUgfCB1bmRlZmluZWQ7XG4gIGluZm86IFJlYWN0Tm9kZSB8IHVuZGVmaW5lZDtcbiAgd2FybmluZzogUmVhY3ROb2RlIHwgdW5kZWZpbmVkO1xuICBlcnJvcjogUmVhY3ROb2RlIHwgdW5kZWZpbmVkO1xufVxuXG5leHBvcnQgY29uc3QgSW5wdXRIaW50OiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBuYW1lLFxuICB2aWV3LFxuICBwb3NpdGlvbixcbiAgY29udGVudCxcbiAgaW5mbyxcbiAgd2FybmluZyxcbiAgZXJyb3Jcbn0pID0+IHtcbiAgaWYgKGluZm8pIHtcbiAgICBjb250ZW50ID0gaW5mbztcbiAgICB2aWV3ID0gJ2luZm8nO1xuICB9XG5cbiAgaWYgKHdhcm5pbmcpIHtcbiAgICBjb250ZW50ID0gd2FybmluZztcbiAgICB2aWV3ID0gJ3dhcm5pbmcnO1xuICB9XG5cbiAgaWYgKGVycm9yKSB7XG4gICAgY29udGVudCA9IGVycm9yO1xuICAgIHZpZXcgPSAnZXJyb3InO1xuICB9XG5cbiAgaWYgKCFjb250ZW50KSB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxIaW50IHRlc3RJZD17YCR7bmFtZX0taW5wdXRIaW50YH0gdmlldz17dmlld30gcG9zaXRpb249e3Bvc2l0aW9ufT5cbiAgICAgIHtjb250ZW50fVxuICAgIDwvSGludD5cbiAgKTtcbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/common/Input/Hint/index.js
// module id = 1664
// module chunks = 118